import { theme } from 'antd'
import { ConfigProviderProps } from 'antd/es/config-provider'
// 国际化失效：https://github.com/ant-design/ant-design/issues/56379
import zhCN from 'antd/es/locale/zh_CN'

export const antdConfig: ConfigProviderProps = {
  locale: zhCN,
  theme: {
    // https://ant-design.antgroup.com/docs/react/css-variables-cn#%E5%BC%80%E5%90%AF-zeroruntime-%E6%A8%A1%E5%BC%8F
    zeroRuntime: true,
    token: {
      borderRadius: 2,
      fontSize: 14,
      colorTextDisabled: theme.getDesignToken().colorText
    }
  },
  button: {
    autoInsertSpace: true
  }
}
